<!-- <template>
  <div class="card shadow-sm border-0 mb-3">
    <div class="card-body">
      <div class="row">
        <div class="col-md-8">
          <h4 class="mb-1">
            {{ contract.client_name }}
          </h4>

          <div class="text-muted mb-2">
            {{ contract.office_address }}
          </div>
        </div>

        <div class="col-md-4 text-right">
          <span class="badge badge-success mb-2"> ACTIVE </span>
          <h6>
            {{ contract.contract_number }}
          </h6>
        </div>
      </div>
    </div>
  </div>
</template> -->
<template>
  <div class="card shadow-sm mb-3">
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <div class="flex-grow-1">
          <h4 class="mb-1 font-weight-bold">
            {{ contract.client_name }}
          </h4>

          <p class="text-muted mb-3">
            <i class="ti ti-map-pin mr-1"></i>
            {{ contract.office_address }}
          </p>

          <div class="contract-summary">
            <div class="summary-item">
              <i class="ti ti-calendar-event text-primary"></i>

              <div>
                <small>Contract Period</small>

                <strong>
                  {{ contract.start_date }}
                  -
                  {{ contract.end_date }}
                </strong>
              </div>
            </div>

            <div class="summary-item">
              <i class="ti ti-users text-success"></i>

              <div>
                <small>Technician</small>

                <strong>{{ employees.length }} Assigned</strong>
              </div>
            </div>

            <div class="summary-item">
              <i class="ti ti-calendar-month text-warning"></i>

              <div>
                <small>Current Period</small>

                <strong>{{ filterDate }}</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="text-right ml-4">
          <span :class="contract.status | contractStatus">
            {{ contract.status | cleanString }}
          </span>

          <div class="mt-3 text-muted">
            <small>Contract Number</small>

            <div class="font-weight-bold">
              {{ contract.contract_number }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderContract",

  components: {
    // DatePicker,
  },

  props: {
    employees: {
      type: Array,

      default: () => [],
    },
    contract: {
      type: Object,
      required: true,
    },

    filterDate: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      localFilterDate: this.filterDate,
    };
  },

  watch: {
    filterDate(val) {
      this.localFilterDate = val;
    },
  },

  methods: {
    changeMonth() {
      this.$emit("update:filterDate", this.localFilterDate);

      this.$emit("change-period");
    },
  },
};
</script>

<style scoped>
.contract-summary {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.summary-item {
  display: flex;
  align-items: center;
}

.summary-item i {
  font-size: 22px;
  margin-right: 12px;
}

.summary-item small {
  display: block;
  color: #8b8b8b;
  font-size: 11px;
}

.summary-item strong {
  display: block;
  font-size: 14px;
  color: #2f3542;
}
</style>